<script lang="ts" setup>
const { y } = useWindowScroll()

function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
</script>

<template>
  <VScaleTransition class="scroll-to-top d-print-none" style="transform-origin: center">
    <VBtn v-show="y > 200" icon @click="scrollToTop">
      <VIcon icon="mdi-arrow-up" size="22" />
    </VBtn>
  </VScaleTransition>
</template>

<style lang="scss">
.scroll-to-top {
  position: fixed !important;

  // To keep button on top of v-layout. E.g. Email app
  z-index: 999;
  inset-block-end: 5%;
  inset-inline-start: 25px;
}
</style>
